<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{on, attrs}">
      <v-text-field
        v-model="date"
        prepend-icon="mdi-calendar"
        readonly
        outlined
        hide-details
        dense
        clearable
        placeholder="Chọn khoảng ngày"
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" no-title scrollable range>
      <v-btn text color="primary" @click="menu = false">
        Hủy
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="dateChange">
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import { DATE_FORMAT, parseHoChiMinhIsoDate } from '@/helpers/dateTime'

export default {
  data: () => ({
    date: [],
    menu: false
  }),
  watch: {
    date(val) {
      if (val === null || val.length === 0) {
        this.$emit('cleared')
      }
    }
  },
  methods: {
    dateChange() {
      if (this.date && this.date.length > 1) {
        if (parseHoChiMinhIsoDate(this.date[0]).isAfter(parseHoChiMinhIsoDate(this.date[1]))) {
          let temp = this.date[0]
          this.date[0] = this.date[1]
          this.date[1] = temp
        }
        this.$refs.menu.save(this.date)
        const startDate = parseHoChiMinhIsoDate(this.date[0])
        const endDate = parseHoChiMinhIsoDate(this.date[1])
        this.$emit('change', [
          startDate
            .startOf('day')
            .toISOString(),
          endDate
            .endOf('day')
            .toISOString()
        ])
        this.date[0] = startDate.format(DATE_FORMAT)
        this.date[1] = endDate.format(DATE_FORMAT)
        this.menu = false
      }
    }
  }
}
</script>
